module.exports = __webpack_public_path__ + "img/appointment.64dd341.jpg";